export const RELATED_CONTENT = [
  {
    image:
      'https://paction-shared-resources.s3.ca-central-1.amazonaws.com/articlePhotos/oiYZB-wmSu.webp',
    category: 'Paw Print 🐾 Stories from Pup Parents',
    title: "The Story of Paction's Co-founder Brooke",
    link: 'https://medium.com/@brookeashleyacton/the-canadian-puppy-industry-what-paction-is-doing-about-it-018ce253beb9',
    external: true
  },
  {
    image:
      'https://paction-shared-resources.s3.ca-central-1.amazonaws.com/articlePhotos/E6z61UP6n.png',
    category: 'Paw Print 🐾 Stories from Pup Parents',
    title: 'The Hidden Costs of Owning a Dog: What You Need to Know',
    link: '/article/hidden-costs-of-owning-a-dog',
    external: false
  },
  {
    image:
      'https://paction-shared-resources.s3.ca-central-1.amazonaws.com/common/time-estimator.webp',
    category: 'Tools & Calculators',
    title: 'Pup Time Estimator',
    link: '/pup-time-estimator',
    external: false
  }
];

export const STEP_LINKS = [
  {
    href: '#feeding-your-pup',
    label: 'Feeding your pup',
    icon: '/icons/calculator-steps/feeding-your-pup.svg',
    alt: 'Dog sitting next to a bag of food and dish'
  },
  {
    href: '#cost-of-care',
    label: 'Cost of care',
    icon: '/icons/calculator-steps/cost-of-care.svg',
    alt: 'Veterinarian pointing to a dog on an exam table'
  },
  {
    href: '#setting-up-your-home',
    label: 'Setting up your home',
    icon: '/icons/calculator-steps/setting-up-your-home.svg',
    alt: 'Dog in front of a fence and house'
  },
  {
    href: '#education-and-training',
    label: 'Education & training',
    icon: '/icons/calculator-steps/education-and-training.svg',
    alt: 'Dog in a graduation hat sitting on a diploma'
  }
];
